import {
  Box,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useAppSelector } from 'src/app/hooks';
import BottomHeader from './Bottom';
import { useLocation, useNavigate } from 'react-router';
import { useEffect, useMemo, useState } from 'react';
import useQueryUrl from 'src/hooks/useQuery';
import TabNetworkAnalysis from 'src/components/TabNetworkAnalysis';
import ModalManageObjectRetail from '../../ModalManageObjectRetail';
import GroupObjectRetail from '../../GroupObjectRetail';
import WidgetsIcon from '@mui/icons-material/Widgets';
import ObjectPreviewRetail from '../../ObjectPreviewRetail';
import TableViewIcon from '@mui/icons-material/TableView';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: white;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

const HeaderWrapperSec = styled(Box)(
  ({ theme }) => `
    background: #F5F5F5;
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    justify-content: space-between;
    width: 100%;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderRetail() {
  const { pathname } = useLocation();
  const menu = pathname.split('/')[1];
  const title = pathname.split('/')[2];
  const query = useQueryUrl();
  const tabQuery = query.get('tab');
  const navigate = useNavigate();
  const [tab, setTab] = useState<string>(tabQuery);

  const { objectListByObjectType } = useAppSelector(
    (state) => state.objectManagement
  );

  const objectListPrevies = useMemo(() => {
    if (title === 'content' || title === 'community') {
      return objectListByObjectType.filter(
        (object) => object.streamType === 'account'
      );
    }
    return objectListByObjectType;
  }, [objectListByObjectType, title]);

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
    navigate(`${pathname}?tab=${newValue}`);
  };

  useEffect(() => {
    setTab(tabQuery);
  }, [tabQuery]);

  const isNetworkAnalysis = () => {
    return title === 'sna' || title === 'dna';
  };

  const isClustering = () => {
    return title === 'clustering';
  };

  const isGoogleReviewMenu = menu === 'google_review';

  const theme = useTheme();
  const matchesUpSm = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <>
      <HeaderWrapper display="flex" alignItems="center">
        <Grid container>
          <Grid item md={12} width="inherit">
            <GroupObjectRetail />
          </Grid>
          <Grid item md={12}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack
                direction={matchesUpSm ? 'row' : 'column'}
                alignItems={matchesUpSm ? 'center' : 'start'}
                spacing={1}
                mt={1.5}
                mb={2.1}
              >
                <ModalManageObjectRetail />
                <ObjectPreviewRetail objectList={objectListPrevies} />
              </Stack>
              <Stack
                sx={{
                  borderRadius: '16px',
                  padding: 1,
                  backgroundColor: theme.colors.primary.lighter
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                    sx={{
                      backgroundColor:
                        tab === 'widget' || !tab
                          ? theme.colors.primary.main
                          : theme.colors.primary.lighter,
                      py: 1,
                      px: 2,
                      borderRadius: '16px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleChange(null, 'widget')}
                  >
                    <WidgetsIcon
                      sx={{
                        color: tab === 'widget' || !tab ? 'white' : '#757575',
                        fontSize: '16px'
                      }}
                    />
                    <Typography
                      fontWeight={600}
                      fontSize="14px"
                      color={tab === 'widget' || !tab ? 'white' : '#757575'}
                    >
                      Widget
                    </Typography>
                  </Stack>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                    sx={{
                      backgroundColor:
                        tab === 'stream_preview'
                          ? theme.colors.primary.main
                          : theme.colors.primary.lighter,
                      py: 1,
                      px: 2,
                      borderRadius: '16px',
                      cursor: 'pointer'
                    }}
                    onClick={() => handleChange(null, 'stream_preview')}
                  >
                    <TableViewIcon
                      sx={{
                        color: tab === 'stream_preview' ? 'white' : '#757575',
                        fontSize: '16px'
                      }}
                    />
                    <Typography
                      fontWeight={600}
                      fontSize="14px"
                      color={tab === 'stream_preview' ? 'white' : '#757575'}
                    >
                      Stream Preview
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
          </Grid>
          {!isClustering() ? (
            <Grid item md={12}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                {
                  isNetworkAnalysis() ? (
                    <TabNetworkAnalysis
                      tab={tab}
                      handleChange={handleChange}
                      label={title}
                    />
                  ) : null
                  // <Tabs
                  //   value={tab !== 'stream_preview' ? 'widget' : tab}
                  //   onChange={handleChange}
                  //   aria-label="basic tabs example"
                  // >
                  //   <Tab label="Widget" value="widget" />
                  //   {isGoogleReviewMenu ? null : (
                  //     <Tab label="Stream Preview" value="stream_preview" />
                  //   )}
                  // </Tabs>
                }
              </Box>
            </Grid>
          ) : null}
        </Grid>
      </HeaderWrapper>
      <HeaderWrapperSec display="flex" alignItems="center">
        <Grid container>
          <Grid item sm={12}>
            <BottomHeader key={title} />
          </Grid>
        </Grid>
      </HeaderWrapperSec>
    </>
  );
}

export default HeaderRetail;
